import axios from 'axios';

// Using environment variables for API endpoints with fallbacks
export const geoLocationApi = axios.create({
  baseURL: process.env.REACT_APP_GEO_API_URL || 'https://geocoding-api.open-meteo.com/v1/search'
});

export const forecastApi = axios.create({
  baseURL: process.env.REACT_APP_FORECAST_API_URL || 'https://api.open-meteo.com/v1/forecast'
});